import {bindCostFieldsToUpdateTotals, createAccountForDepreciationAutocomplete, initDatePickers} from '../shared/capex-form-fields';

export default function () {
    dropdowns();
    currencyInputs();
    initDatePickers();
    createAccountForDepreciationAutocomplete('/Finance/CapExGeneralRequest');
}

const dropdowns = () => {
    const k_otherDetails = $('[name="EquipmentType"]').data('kendoDropDownList');
    if (k_otherDetails) k_otherDetails.bind('change', showHideOtherDetails);
}

const showHideOtherDetails = (object) => {
}

const currencyInputs = () => {
    bindCostFieldsToUpdateTotals();

    const k_laborToOperateCurrent = $('[name="LaborToOperateCurrent"]');
    if (k_laborToOperateCurrent) k_laborToOperateCurrent.bind('change', updateAnnualOperatingCost);
    const k_monthlyDepreciationCurrent = $('[name="MonthlyDepreciationCurrent"]');
    if (k_monthlyDepreciationCurrent) k_monthlyDepreciationCurrent.bind('change', updateAnnualOperatingCost);
    const k_suppliesCurrent = $('[name="SuppliesCurrent"]');
    if (k_suppliesCurrent) k_suppliesCurrent.bind('change', updateAnnualOperatingCost);
    const k_trainingCurrent = $('[name="TrainingCurrent"]');
    if (k_trainingCurrent) k_trainingCurrent.bind('change', updateAnnualOperatingCost);
    const k_maintenanceCurrent = $('[name="MaintenanceCurrent"]');
    if (k_maintenanceCurrent) k_maintenanceCurrent.bind('change', updateAnnualOperatingCost);
    const k_afterWarrantyCurrent = $('[name="AfterWarrantyCurrent"]');
    if (k_afterWarrantyCurrent) k_afterWarrantyCurrent.bind('change', updateAnnualOperatingCost);
    const k_partsLaborSvsContractCurrent = $('[name="PartsLaborSvsContractCurrent"]');
    if (k_partsLaborSvsContractCurrent) k_partsLaborSvsContractCurrent.bind('change', updateAnnualOperatingCost);
    const k_laborToOperateProposed = $('[name="LaborToOperateProposed"]');
    if (k_laborToOperateProposed) k_laborToOperateProposed.bind('change', updateAnnualOperatingCost);
    const k_monthlyDepreciationProposed = $('[name="MonthlyDepreciationProposed"]');
    if (k_monthlyDepreciationProposed) k_monthlyDepreciationProposed.bind('change', updateAnnualOperatingCost);
    const k_suppliesProposed = $('[name="SuppliesProposed"]');
    if (k_suppliesProposed) k_suppliesProposed.bind('change', updateAnnualOperatingCost);
    const k_trainingProposed = $('[name="TrainingProposed"]');
    if (k_trainingProposed) k_trainingProposed.bind('change', updateAnnualOperatingCost);
    const k_maintenanceProposed = $('[name="MaintenanceProposed"]');
    if (k_maintenanceProposed) k_maintenanceProposed.bind('change', updateAnnualOperatingCost);
    const k_afterWarrantyProposed = $('[name="AfterWarrantyProposed"]');
    if (k_afterWarrantyProposed) k_afterWarrantyProposed.bind('change', updateAnnualOperatingCost);
    const k_partsLaborSvsContractProposed = $('[name="PartsLaborSvsContractProposed"]');
    if (k_partsLaborSvsContractProposed) k_partsLaborSvsContractProposed.bind('change', updateAnnualOperatingCost);
}

const updateAnnualOperatingCost = () => {
    //Get Current Costs
    const $laborToOperateCurrent = $('[name="LaborToOperateCurrent"]');
    const $monthlyDepreciationCurrent = $('[name="MonthlyDepreciationCurrent"]');
    const $suppliesCurrent = $('[name="SuppliesCurrent"]');
    const $trainingCurrent = $('[name="TrainingCurrent"]');
    const $maintenanceCurrent = $('[name="MaintenanceCurrent"]');
    const $afterWarrantyCurrent = $('[name="AfterWarrantyCurrent"]');
    const $partsLaborSvsContractCurrent = $('[name="PartsLaborSvsContractCurrent"]');
    const $totalCurrent = $('[name="TotalCurrent"]');
    const $totalCurrentDisplay = $('.js-total-current');

    //Get Proposed Costs
    const $laborToOperateProposed = $('[name="LaborToOperateProposed"]');
    const $monthlyDepreciationProposed = $('[name="MonthlyDepreciationProposed"]');
    const $suppliesProposed = $('[name="SuppliesProposed"]');
    const $trainingProposed = $('[name="TrainingProposed"]');
    const $maintenanceProposed = $('[name="MaintenanceProposed"]');
    const $afterWarrantyProposed = $('[name="AfterWarrantyProposed"]');
    const $partsLaborSvsContractProposed = $('[name="PartsLaborSvsContractProposed"]');
    const $totalProposed = $('[name="TotalProposed"]');
    const $totalProposedDisplay = $('.js-total-proposed');

    const $netChange = $('[name="NetChangeInAnnualOperating"]');
    const $netChangeDisplay = $('.js-net-difference');

    //Calculate Current Total
    let totalCurrent = 0;
    if ($laborToOperateCurrent.length) totalCurrent += Number($laborToOperateCurrent.val());
    if ($monthlyDepreciationCurrent.length) totalCurrent += Number($monthlyDepreciationCurrent.val());
    if ($suppliesCurrent.length) totalCurrent += Number($suppliesCurrent.val());
    if ($trainingCurrent.length) totalCurrent += Number($trainingCurrent.val());
    if ($maintenanceCurrent.length) totalCurrent += Number($maintenanceCurrent.val());
    if ($afterWarrantyCurrent.length) totalCurrent += Number($afterWarrantyCurrent.val());
    if ($partsLaborSvsContractCurrent.length) totalCurrent += Number($partsLaborSvsContractCurrent.val());
    $totalCurrent.val(totalCurrent);

    //Calculate Proposed Total
    let totalProposed = 0;
    if ($laborToOperateProposed.length) totalProposed += Number($laborToOperateProposed.val());
    if ($monthlyDepreciationProposed.length) totalProposed += Number($monthlyDepreciationProposed.val());
    if ($suppliesProposed.length) totalProposed += Number($suppliesProposed.val());
    if ($trainingProposed.length) totalProposed += Number($trainingProposed.val());
    if ($maintenanceProposed.length) totalProposed += Number($maintenanceProposed.val());
    if ($afterWarrantyProposed.length) totalProposed += Number($afterWarrantyProposed.val());
    if ($partsLaborSvsContractProposed.length) totalProposed += Number($partsLaborSvsContractProposed.val());
    $totalProposed.val(totalProposed);

    //Set Totals
    $totalCurrentDisplay.text(kendo.format('{0:C2}', totalCurrent));
    $totalProposedDisplay.text(kendo.format('{0:C2}', totalProposed));
    $netChange.val(totalCurrent - totalProposed);
    $netChangeDisplay.text(kendo.format('{0:C2}', totalCurrent - totalProposed));
}
